export const PRIVATETYPE = {
  public: 0, // 公开
  administrators: 1, //管理员设为私密
  notClass: 2, // 待分类
  privacy: 3, // 私密
};
